import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const Delete = ({ open, handleClose, handleConfirm, message }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.1)", 
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "46%",
          left: "52%",
          transform: "translate(-50%, -50%)",
          width: 510,
          bgcolor: "background.paper",
          border: "0px solid #000",
        //   boxShadow: 24,
          p: 4,
          borderRadius: '8px',
        }}
      >
        <Typography id="modal-title"
         variant="body1"
         component="p"
         style={{
            fontWeight: 'bold',
            color: '#303030',
          }}
         >
          Delete Invoice ?
        </Typography>
        <Typography mt={2} variant="h6" component="h2">
          {message}
        </Typography>

        <Box mt={4} mb={-1} display="flex" >
            
          <Typography
          style={{marginLeft:'19.50vw',
            marginRight:'2.50vw',
            cursor: 'pointer',
          }}
           variant="contained"
            color="#2A80D5"
            fontWeight={500}
            onClick={handleConfirm}>
            AGREE
          </Typography>

          <Typography variant="contained"
           style={{
            cursor: 'pointer'
           }}
           color="#2A80D5"
           fontWeight={500}
           onClick={handleClose}>
            DISAGREE
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default Delete;
